import { render } from "./ReviewRoom.vue?vue&type=template&id=0b7e2152"
import script from "./ReviewRoom.vue?vue&type=script&lang=js"
export * from "./ReviewRoom.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/MT/2025/jebsen/files/components/com_cruise/assets/js/booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__